<main role="main" class="flex-shrink-0">
  <div class="">
    <router-outlet></router-outlet>
  </div>
</main>